import { Box } from "@mui/material";
import { type FunctionComponent, type PropsWithChildren, useState } from "react";

import { ExplosionGraphic, ExplosionGraphicSkeleton, ExplosionGraphicTooltipStyled } from "./ExplosionGraphicTooltip.styles";

export const dataTestId = {
    tooltip: "sparePartsFinder.overview.list.componentGroupCard.tooltip",
    trigger: "sparePartsFinder.overview.list.componentGroupCard.tooltipTrigger",
};

export interface ExplosionGraphicTooltipProps {
    assetPath: string;
}

export const ExplosionGraphicTooltip: FunctionComponent<PropsWithChildren<ExplosionGraphicTooltipProps>> = ({ assetPath, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const onMouseEnter = () => {
        if (!isLoaded) {
            const image = new Image();
            image.src = assetPath;
            image.onload = () => setIsLoaded(true);
        }

        setIsOpen(true);
    };

    return (
        <ExplosionGraphicTooltipStyled
            content={<Box data-testid={dataTestId.tooltip}>{isLoaded ? <ExplosionGraphic src={assetPath} /> : <ExplosionGraphicSkeleton />}</Box>}
            open={isOpen}
            placement="right"
        >
            <Box
                data-testid={dataTestId.trigger}
                onBlur={() => setIsOpen(false)}
                onFocus={() => onMouseEnter()}
                onMouseEnter={() => onMouseEnter()}
                onMouseLeave={() => setIsOpen(false)}
            >
                {children}
            </Box>
        </ExplosionGraphicTooltipStyled>
    );
};
